import React from 'react';
import classNames from 'classnames';

type InsightsPaginationProps = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalCount: number;
  itemCountOnPage: number;
  currentPage: number;
  pageSize: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
};

const InsightsPagination: React.FC<InsightsPaginationProps> = ({
  hasNextPage,
  hasPreviousPage,
  totalCount,
  itemCountOnPage,
  currentPage,
  pageSize,
  onPreviousPage,
  onNextPage,
}) => {
  const rangeText = (() => {
    if (totalCount === 0) {
      return 'No clients';
    }
    if (itemCountOnPage === 0) {
      return `Showing 0 of ${totalCount} clients`;
    }
    const start = (currentPage - 1) * pageSize + 1;
    const end = (currentPage - 1) * pageSize + itemCountOnPage;
    return `Showing ${start}–${end} of ${totalCount} clients`;
  })();

  return (
    <div className="flex items-center justify-center space-x-4 py-4">
      <button
        onClick={onPreviousPage}
        disabled={!hasPreviousPage}
        className={classNames(
          'rounded-md px-4 py-2 text-small-caption',
          'border border-neutral-75 bg-white text-green-150',
          'hover:bg-neutral-25 focus:outline-none focus:ring-2 focus:ring-secondary-50',
          'disabled:cursor-not-allowed disabled:opacity-50',
        )}
      >
        Previous
      </button>

      <span className="text-caption text-neutral-125">{rangeText}</span>

      <button
        onClick={onNextPage}
        disabled={!hasNextPage}
        className={classNames(
          'rounded-md px-4 py-2 text-small-caption',
          'border border-neutral-75 bg-white text-green-150',
          'hover:bg-neutral-25 focus:outline-none focus:ring-2 focus:ring-secondary-50',
          'disabled:cursor-not-allowed disabled:opacity-50',
        )}
      >
        Next
      </button>
    </div>
  );
};

export default InsightsPagination;
